(function () {
  var desktopQuery = window.matchMedia('(min-width: 1200px)');

  function loadDeferredMegaNav(nav) {
    if (!nav || !nav.hasAttribute('data-deferred-mega-nav')) return Promise.resolve(nav);
    if (nav.__deferredMegaPromise) return nav.__deferredMegaPromise;

    var sectionId = nav.getAttribute('data-deferred-mega-section-id');
    if (!sectionId) return Promise.resolve(nav);

    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    nav.__deferredMegaPromise = fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Deferred mega nav section request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sourceNav = doc.querySelector('.header-navigation-menu');

        if (!sourceNav || sourceNav.hasAttribute('data-deferred-mega-nav')) {
          throw new Error('Deferred mega nav source missing');
        }

        nav.innerHTML = sourceNav.innerHTML;
        nav.removeAttribute('data-deferred-mega-nav');
        nav.removeAttribute('data-deferred-mega-section-id');
        delete nav.dataset.navigationMenuBound;
        initHeaderNavigationMenu(nav);

        return nav;
      })
      .catch(function (error) {
        console.warn('[header-navigation-menu] Deferred mega nav failed:', error);
        return nav;
      })
      .finally(function () {
        nav.__deferredMegaPromise = null;
      });

    return nav.__deferredMegaPromise;
  }

  function bindDeferredMegaNav(nav) {
    if (!nav || nav.dataset.deferredMegaBound === 'true') return;

    nav.dataset.deferredMegaBound = 'true';

    var loadOnIntent = function () {
      if (!desktopQuery.matches) return;
      loadDeferredMegaNav(nav);
    };

    nav.addEventListener('mouseenter', loadOnIntent, { once: true });
    nav.addEventListener('focusin', loadOnIntent, { once: true });

    if (desktopQuery.matches) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function () {
          loadDeferredMegaNav(nav);
        }, { timeout: 2500 });
      } else {
        window.setTimeout(function () {
          loadDeferredMegaNav(nav);
        }, 1500);
      }
    }
  }

  function initHeaderNavigationMenu(root) {
    var nav = root.matches && root.matches('.header-navigation-menu')
      ? root
      : root.querySelector('.header-navigation-menu');

    if (!nav || nav.dataset.navigationMenuBound === 'true') return;

    if (nav.hasAttribute('data-deferred-mega-nav')) {
      bindDeferredMegaNav(nav);
    }

    nav.dataset.navigationMenuBound = 'true';

    var allItems = nav.querySelectorAll('.header-navigation-menu__item');
    var items = nav.querySelectorAll('.header-navigation-menu__item.has-mega');
    var openDelay = 180;
    var openTimer = null;
    var closeDelay = 250;
    var closeTimer = null;

    function clearTimers() {
      if (openTimer) clearTimeout(openTimer);
      if (closeTimer) clearTimeout(closeTimer);
      openTimer = null;
      closeTimer = null;
    }

    function clearAll() {
      items.forEach(function (el) {
        el.classList.remove('mega-active');
      });
    }

    function lockMenuHeight(li) {
      var megaInner = li.querySelector('.mega-menu__inner');
      if (!megaInner) return;

      if (megaInner.dataset.heightLocked === 'true') return;

      var currentHeight = megaInner.getBoundingClientRect().height;

      if (!currentHeight) {
        currentHeight = megaInner.scrollHeight;
      }

      megaInner.style.height = currentHeight + 'px';
      megaInner.style.overflowY = 'auto';
      megaInner.dataset.heightLocked = 'true';
    }

    function open(li) {
      clearTimers();
      clearAll();
      li.classList.add('mega-active');

      requestAnimationFrame(function () {
        lockMenuHeight(li);
      });
    }

    function close(li) {
      clearTimers();
      li.classList.remove('mega-active');
    }

    function scheduleOpen(li) {
      clearTimers();
      clearAll();

      openTimer = setTimeout(function () {
        var megaMenu = li.querySelector('.mega-menu');

        var overLi = li.matches(':hover');
        var overMenu = megaMenu ? megaMenu.matches(':hover') : false;

        if (!overLi && !overMenu) return;

        open(li);
      }, openDelay);
    }

    function scheduleClose(li) {
      if (openTimer) clearTimeout(openTimer);
      if (closeTimer) clearTimeout(closeTimer);

      openTimer = null;
      closeTimer = setTimeout(function () {
        var megaMenu = li.querySelector('.mega-menu');

        var overLi = li.matches(':hover');
        var overMenu = megaMenu ? megaMenu.matches(':hover') : false;

        if (overLi || overMenu) return;

        li.classList.remove('mega-active');
        closeTimer = null;
      }, closeDelay);
    }

    allItems.forEach(function (li) {
      if (li.classList.contains('has-mega') && li.querySelector('.mega-menu__inner')) return;

      li.addEventListener('mouseenter', function () {
        clearTimers();
        clearAll();
      });
    });

    items.forEach(function (li) {
      var megaMenu = li.querySelector('.mega-menu');
      var megaBackdrop = li.querySelector('.mega-backdrop');
      var megaInner = li.querySelector('.mega-menu__inner');

      if (!megaInner) return;

      li.addEventListener('mouseenter', function () {
        scheduleOpen(li);
      });

      li.addEventListener('mouseleave', function () {
        scheduleClose(li);
      });

      if (megaMenu) {
        megaMenu.addEventListener('mouseenter', function () {
          if (closeTimer) clearTimeout(closeTimer);
          closeTimer = null;
          li.classList.add('mega-active');
        });

        megaMenu.addEventListener('mouseleave', function () {
          scheduleClose(li);
        });
      }

      if (megaBackdrop) {
        megaBackdrop.addEventListener('mouseenter', function () {
          close(li);
        });
      }
    });

    if (nav.dataset.navigationMenuActionsBound !== 'true') {
      nav.dataset.navigationMenuActionsBound = 'true';

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;

        nav.querySelectorAll('.header-navigation-menu__item').forEach(function (el) {
          el.classList.remove('mega-active');
        });
      });

      nav.addEventListener('click', function (event) {
        var toggleBtn = event.target.closest('[data-show-more]');
        if (!toggleBtn || !nav.contains(toggleBtn)) return;

        var block = toggleBtn.closest('.mega-sublist-block');
        if (!block) return;

        var list = block.querySelector('.mega-sublist');
        if (!list) return;

        var isExpanded = list.classList.toggle('is-expanded');

        toggleBtn.setAttribute('aria-expanded', String(isExpanded));
        toggleBtn.textContent = isExpanded ? 'Weniger anzeigen' : 'Mehr anzeigen';

        if (isExpanded) {
          var scrollContainer = toggleBtn.closest('.mega-menu__inner');
          if (!scrollContainer) return;

          requestAnimationFrame(function () {
            var targetScroll = block.offsetTop + block.offsetHeight - scrollContainer.clientHeight;

            scrollContainer.scrollTo({
              top: Math.max(targetScroll, 0),
              behavior: 'smooth'
            });
          });
        }
      });
    }
  }

  initHeaderNavigationMenu(document);
})();
